import { render, staticRenderFns } from "./ClienteDadosDevolucoesImpropria.vue?vue&type=template&id=d879be54&scoped=true&"
import script from "./ClienteDadosDevolucoesImpropria.vue?vue&type=script&lang=js&"
export * from "./ClienteDadosDevolucoesImpropria.vue?vue&type=script&lang=js&"
import style0 from "./ClienteDadosDevolucoesImpropria.vue?vue&type=style&index=0&id=d879be54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879be54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
